const api = process.env.REACT_APP_API_ENDPOINT;
const hub = process.env.REACT_APP_HUB_ENDPOINT;

const config = {
  api,
  hub,
};
export default config;
